import React from 'react'
import _ from 'lodash'


import './filterpanel.css'

const FilterPanelControl = ({title, filter, filterKey, onClearFilter, children}) => 
    <div className="form-group">
        {title && <label className="control-label">{title}</label>}
        <div style={{width:98+'%'}}>
            {children}
            {filter[filterKey] && <button className="clear-filter" onClick={() => onClearFilter(filterKey)}>x</button>}
        </div>
    </div>

class Filterpanel extends React.Component {
    state = {
        panelVisible: false
    }

    togglePanelVisible() {
        this.setState(s => ({ panelVisible: !s.panelVisible }))
    }

    filterChanged(property, value) {
        if (!value) 
            value = null

        let newFilter = Object.assign({}, this.props.filter)
        _.set(newFilter, property, value)
        if (this.props.onFilterChanged) this.props.onFilterChanged(newFilter)
    }

    clearFilter(property) {
        this.filterChanged(property, null)
    }

    render() {
        let { filter } = this.props

        let soneOptions = this.props.soner.map(s => <option key={s.Id} value={s.Id}>{s.Tekst}</option>)
        soneOptions = _.concat([<option key="_blank" value='' />], soneOptions)
        let statusOptions = this.props.statusTyper.map(s => <option key={s.Id} value={s.Tekst}>{s.Tekst}</option>)
        statusOptions = _.concat([<option key="_blank" value='' />], statusOptions)

        let avlesertyper = this.props.avlesertyper.map(at => <option key={at.Id} value={at.Id}>{at.Tekst}</option>)
        avlesertyper = _.concat([<option key="_blank" value='' />], avlesertyper)

        let avtaletyper = this.props.avtaletyper.map(at => <option key={at} value={at}>{at}</option>)
        avtaletyper = _.concat([<option key="_blank" value='' />], avtaletyper)

        var date = new Date();
        var year = date.getFullYear() + 1;

        let years = _.range(year, 1980, -1).map(y => <option key={y} value={y}>{y}</option>)
        years = _.concat([<option key="_blank" value='' />], years)

        return (
            <div className="vm-filterpanel">
                <div className="control-list">
                    <FilterPanelControl title="Søk" filter={filter} filterKey="adresse" onClearFilter={v => this.clearFilter(v)}>
                        <input 
                            className="form-control"
                            placeholder="Adresse eller målernummer"
                            type="text"
                            value={filter.adresse || ''}
                            onChange={e => this.filterChanged('adresse', e.target.value)}
                        />
                    </FilterPanelControl>                    

                    <FilterPanelControl title="Status" filter={filter} filterKey="status" onClearFilter={v => this.clearFilter(v)}>
                        <select className="form-control" 
                            value={filter.status || ''} onChange={e => this.filterChanged('status', e.target.value)}>
                            {statusOptions}
                        </select>
                    </FilterPanelControl>

                    <FilterPanelControl title="Sone" filter={filter} filterKey="sone" onClearFilter={v => this.clearFilter(v)}>
                        <select className="form-control" 
                            value={filter.sone || ''} onChange={e => this.filterChanged('sone', +e.target.value)}>
                            {soneOptions}
                        </select>
                    </FilterPanelControl>

                    <FilterPanelControl title="Installert før" filter={filter} filterKey="dato" onClearFilter={v => this.clearFilter(v)}>
                        <select className="form-control"
                            value={filter.dato || ''}  
                            onChange={e => this.filterChanged('dato', e.target.value ? +e.target.value : null)}>
                            {years}
                        </select>
                    </FilterPanelControl>

                    <FilterPanelControl title="Avlesertype" filter={filter} filterKey="avlesertype" onClearFilter={v => this.clearFilter(v)}>
                        <select className="form-control" 
                            value={this.props.filter.avlesertype || ''} 
                            onChange={e => this.filterChanged('avlesertype', e.target.value ? +e.target.value : null)}>
                            {avlesertyper}
                        </select>
                    </FilterPanelControl>

                    <FilterPanelControl title="Avtaletype" filter={filter} filterKey="avtaletype" onClearFilter={v => this.clearFilter(v)}>
                        <select className="form-control" 
                            value={this.props.filter.avtaletype || ''} 
                            onChange={e => this.filterChanged('avtaletype', e.target.value)}>
                            {avtaletyper}
                        </select>
                    </FilterPanelControl>

                    {this.props.filter.polygon &&
                        <FilterPanelControl filter={filter} filterKey="polygon" onClearFilter={v => this.clearFilter(v)}>
                            <span className="form-control utvalg">Utvalg i kart</span>
                        </FilterPanelControl>
                    }
                </div>
            </div>
        )
    }
}
export default Filterpanel



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/rediger/filterpanel.jsx